(() => {
  const globalKey = 'FogattiBuyboxPromotion';

  if (window[globalKey]) {
    window[globalKey].initialize(document);
    return;
  }

  const countdownNodes = new Set();
  const twoDigits = (value) => String(Math.max(0, value)).padStart(2, '0');

  function updateCountdown(node, now) {
    if (!node.isConnected) {
      countdownNodes.delete(node);
      return;
    }

    const endTime = Date.parse(node.dataset.fgCountdownEnd || '');
    if (!Number.isFinite(endTime)) return;

    const remaining = endTime - now;
    const detailed = node.querySelector('[data-fg-countdown-detailed]');
    const compact = node.querySelector('[data-fg-countdown-output]');
    const expired = node.querySelector('[data-fg-countdown-expired]');

    if (remaining <= 0) {
      if ((node.dataset.fgExpiredBehavior || 'hide') === 'hide') {
        node.hidden = true;
      } else {
        if (detailed) detailed.hidden = true;
        if (compact) compact.hidden = true;
        if (expired) expired.hidden = false;
      }
      return;
    }

    node.hidden = false;
    if (detailed) detailed.hidden = false;
    if (compact) compact.hidden = false;
    if (expired) expired.hidden = true;

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    node.querySelector('[data-fg-countdown-days]')?.replaceChildren(document.createTextNode(twoDigits(days)));
    node.querySelector('[data-fg-countdown-hours]')?.replaceChildren(document.createTextNode(twoDigits(hours)));
    node.querySelector('[data-fg-countdown-minutes]')?.replaceChildren(document.createTextNode(twoDigits(minutes)));
    node.querySelector('[data-fg-countdown-seconds]')?.replaceChildren(document.createTextNode(twoDigits(seconds)));
    if (compact) compact.textContent = `${twoDigits(days)}d ${twoDigits(hours)}:${twoDigits(minutes)}:${twoDigits(seconds)}`;
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-fg-promotion][data-fg-countdown-end]').forEach((node) => {
      if (!node.dataset.fgCountdownEnd?.trim()) return;
      countdownNodes.add(node);
      updateCountdown(node, Date.now());
    });

    scope.querySelectorAll('[data-fg-atc-offer]').forEach((offer) => {
      if (offer.dataset.fgAtcReady === 'true') return;
      const form = offer.closest('form');
      const addButton = form?.querySelector('[data-add-to-cart]');
      const code = offer.dataset.fgAutoCopyCode?.trim();

      if (addButton && code && offer.dataset.fgCopyOnAtc === 'true') {
        addButton.addEventListener('click', () => {
          navigator.clipboard?.writeText(code).then(() => {
            const status = offer.querySelector('[data-fg-promo-copy-status]');
            if (!status) return;
            status.hidden = false;
            window.setTimeout(() => { status.hidden = true; }, 2600);
          }).catch(() => {});
        });
      }

      offer.dataset.fgAtcReady = 'true';
    });
  }

  function closePriceProtectionDetails() {
    document.querySelectorAll('[data-fg-price-protection][open]').forEach((details) => {
      details.open = false;
    });
  }

  const timer = window.setInterval(() => {
    const now = Date.now();
    countdownNodes.forEach((node) => updateCountdown(node, now));
  }, 1000);

  window.addEventListener('pagehide', () => window.clearInterval(timer), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-fg-price-protection]')) return;
    closePriceProtectionDetails();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDetails = document.querySelector('[data-fg-price-protection][open]');
    if (!openDetails) return;
    openDetails.open = false;
    openDetails.querySelector('summary')?.focus();
  });

  window[globalKey] = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
